import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.75, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className="block overflow-hidden pb-[0.14em] -mb-[0.14em]">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "115%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 0.95, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const Marquee = ({ items }) => {
  const row = (hidden) => (
    <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
      {items.map((it, i) => (
        <span
          key={i}
          className="flex items-center gap-5 pr-5 font-display text-lg sm:text-xl text-ink whitespace-nowrap"
        >
          <svg width="14" height="14" viewBox="0 0 14 14" className="text-saffron" aria-hidden="true">
            <circle cx="7" cy="7" r="4" fill="currentColor" />
          </svg>
          {it}
        </span>
      ))}
    </div>
  );
  return (
    <div className="overflow-hidden border-y border-[#E5DECF] bg-cream py-5">
      <div className="marquee-track flex w-max">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
};
